import React, { useState } from "react";
import SideNavbar from "./Navbar/SideNavbar";
import RequestForm from "./RequestSection/RequestForm";
import { useSelector} from "react-redux";
import ApiDesc from "./ApiDetails/ApiDesc";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Paper, Tab } from "@mui/material";

function ApiHelpMain() {
  const [tabValue, setTabValue] = useState(0);
  const state = useSelector((state) => state);
  const { activeApi } = useSelector((state) => state.apiHelpSlice);

  return (
    <div className="width-100 height-100 flex">
      <div className="sidebar">
        <SideNavbar></SideNavbar>
      </div>

      <div className="main-content">
        <div className="flex header">
          <span className="header-text">{activeApi}</span>
        </div>
        <Paper
          elevation={5}
          className="height-100 width-100"
          sx={{ overflow: "hidden" }}>
          <TabContext value={tabValue}>
            <TabList
              onChange={(e, value) => setTabValue(value)}
              textColor="grey"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "grey",
                  color: "grey",
                },
              }}>
              <Tab value={0} label="Details" />
              <Tab value={1} label="Try API" />
            </TabList>
            <TabPanel
              value={0}
              className="height-100 scrollBar tab-panel">
              <ApiDesc />
            </TabPanel>
            <TabPanel
              value={1}
              className="height-100 scrollBar tab-panel">
              <RequestForm />
            </TabPanel>
          </TabContext>
        </Paper>
      </div>
    </div>
  );
}

export default ApiHelpMain;
